<template>
    <div class="prod-rating-summary">
        <v-row
            class="align-center justify-center"
        >
            <v-col
                cols="12"
                sm="6"
                class="col-review-avg"
            >
                <div
                    class="d-flex flex-column align-center justify-center"
                >
                    <h5
                        class="py-0 my-0"
                    >
                        OVERALL RATING
                    </h5>
                    <div
                        class="d-flex"
                    >
                        <span class="font-size-3 line-height-1">
                            {{ summary.average }}
                        </span>
                        <div
                            class="d-flex flex-column align-start justify-center ms-4"
                        >
                            <StarRating
                                :rating="summary.average"
                                :increment="0.1"
                                :show-rating="false"
                                :star-size="10"
                                :rounded-corners="true"
                                active-color="#333"
                                border-color="#333"
                                inactive-color="#fff"
                                :border-width="1"
                                readonly
                            ></StarRating>
                            <span
                                class="font-size-8"
                            >
                                {{ summary.total }} Review<template v-if="summary.total > 1">s</template>
                            </span>
                        </div>
                    </div>
                    <div
                        class="mt-2"
                    >
                        <slot name="button"></slot>
                    </div>
                </div>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                class="col-review-snapshot"
            >
                <ProductRatingSnapshot
                    :counts="summary.counts"
                    :total="summary.total"
                ></ProductRatingSnapshot>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ReviewSummary
    } from '~/types';
    import ProductRatingSnapshot from '~/components/products/reviews/ProductRatingSnapshot/ProductRatingSnapshot.vue';
    import StarRating from 'x1-base/components/star-rating/StarRating/StarRating.vue';

    defineProps<{
        summary: ReviewSummary;
    }>();
</script>

<style lang="scss">
.prod-rating-summary {
    .col-review-avg {
        max-width: 200px;
    }

    .col-review-snapshot {
        max-width: 360px;
    }
}
</style>
